import { get } from '@/utils/request';

export const resourceByUUID = (id) => {
  return get(`/api/v1/resource_by_uuid/${id}`);
};
